<template>
<div class="row align-center justify-center fill-height">
  <div class="px-5 pb-5 v-card v-sheet theme--light">
    <v-flex>
      <img src="../assets/error404.png" alt="">
      <h1 class="display-1 font-weight-light text-center mb-10 mb-10">Application not found</h1>
    </v-flex>
  </div>
</div>
</template>

<script>

export default {
  name: 'ApplicationNotFound'
}
</script>